/**
 * AXIS Foil Guide on axisfoils.com (R-535, 2026-10-23): the Live2Kite Foil Assistant's engine (theme/l2k-guide), with
 * an AXIS look and name. Evan (through the Chief of Staff): "For Avatars run the live2kite faces, randomized, and show me
 * what it would look like on the preview". The faces are the Live2Kite set, AI-generated images of no real person
 * supplied by Evan; one is picked at random per visitor and kept for the visit (sessionStorage), ?axface=N (1 to 9)
 * shows face N for checking a preview.
 *
 * No AI and no server. The flow file (axis-guide-flow.json, from axis-advisor/scripts/axis-guide-build.js) holds the
 * questions, axisfoils.com's own policy answers and the FRONT WINGS to suggest per discipline and level, read from the
 * Live2Kite guide's routes. axisfoils.com sells parts, so a suggestion opens the AXIS builder with that wing chosen
 * (the builder fit-checks every part after it); the guide never pairs parts itself and never points to Live2Kite's
 * packages. Prices are read live through the Section Rendering API (sections/axis-guide-product.liquid).
 *
 * One front door with Shopify Inbox when its embed is on the page: typed questions and a summary of the answers go to
 * the Inbox chat on the visitor's tap, Inbox's own button is hidden where the guide runs and its unread dot shows on the
 * guide. Without Inbox, "talk to a person" goes to the contact form.
 *
 * Honest by construction: the header and first message say it is an automated guide; nothing is added to the cart.
 * Accessibility: a real <button> launcher, a dialog with a focus trap and Escape, a polite live log, 44px targets, no
 * sound, and no animation under prefers-reduced-motion.
 */
(function () {
  'use strict';
  var root = document.getElementById('AXISGuide');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var NAME = 'AXIS Foil Guide';
  var FLOW_URL = root.getAttribute('data-flow');
  var KEY = 'axis-guide-v1';
  var PHOTO = pickFace();

  // A random face per visitor, the same on every page of the visit.
  function pickFace() {
    var list = (root.getAttribute('data-photos') || '').split(',').filter(Boolean);
    if (!list.length) return '';
    var forced = parseInt((location.search.match(/[?&]axface=(\d+)/) || [])[1], 10);
    if (forced >= 1 && forced <= list.length) return list[forced - 1];
    try { var kept = sessionStorage.getItem(KEY + '-face'); if (kept && list.indexOf(kept) >= 0) return kept; } catch (e) {}
    var pick = list[Math.floor(Math.random() * list.length)];
    try { sessionStorage.setItem(KEY + '-face', pick); } catch (e) {}
    return pick;
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var flow = null;
  var state = load() || { open: false, path: [] };
  var launcher, panel, log, choices, ask, askInput, lastFocus;

  function load() { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; } }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* private mode: fine */ } }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function find(list, key) { for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i]; return null; }
  function builderUrl(params) {
    var u = flow.links.builder;
    Object.keys(params || {}).forEach(function (k) { u += (u.indexOf('?') < 0 ? '?' : '&') + k + '=' + encodeURIComponent(params[k]); });
    return u;
  }

  // ---------- the shell ----------
  function build() {
    launcher = el('button', 'axg-launcher');
    launcher.type = 'button';
    launcher.setAttribute('aria-haspopup', 'dialog');
    launcher.setAttribute('aria-label', 'Chat with the ' + NAME);
    var img = el('img');
    img.src = PHOTO; img.alt = ''; img.width = 52; img.height = 52; img.decoding = 'async';
    launcher.appendChild(img);
    launcher.appendChild(el('span', 'axg-label', 'Chat'));
    var tip = el('span', 'axg-tip', 'Not sure which wing? Ask me.');
    tip.setAttribute('aria-hidden', 'true');
    launcher.appendChild(tip);
    launcher.addEventListener('click', function () { if (launcher.classList.contains('axg-unread') && openChat()) return; open(); });

    panel = el('div', 'axg-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'axg-title');
    panel.hidden = true;

    var head = el('div', 'axg-head');
    var face = el('img', 'axg-face');
    face.src = PHOTO; face.alt = NAME + ', an AI-generated character'; face.width = 32; face.height = 32;
    var titles = el('div', 'axg-titles');
    var h = el('h2', 'axg-title', NAME);
    h.id = 'axg-title';
    titles.appendChild(h);
    titles.appendChild(el('p', 'axg-sub', 'Automated guide, AXIS Foils'));
    var close = el('button', 'axg-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close the guide');
    // a minus in a round white button, as Inbox closes its own window, so guide and chat read as one window
    close.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 12h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    close.addEventListener('click', shut);
    head.appendChild(face); head.appendChild(titles); head.appendChild(close);

    log = el('div', 'axg-log');
    log.setAttribute('role', 'log');
    log.setAttribute('aria-live', 'polite');
    log.setAttribute('aria-relevant', 'additions');
    log.tabIndex = 0;
    log.setAttribute('aria-label', 'Conversation');

    choices = el('div', 'axg-choices');
    choices.setAttribute('role', 'group');
    choices.setAttribute('aria-label', 'Your answer');

    // The visitor's own words go to the Inbox chat. Hidden until the Inbox embed is on the page.
    ask = el('form', 'axg-ask');
    ask.hidden = true;
    ask.setAttribute('aria-label', 'Ask AXIS a question');
    askInput = el('input');
    askInput.type = 'text'; askInput.name = 'q'; askInput.maxLength = 500; askInput.autocomplete = 'off';
    askInput.placeholder = 'Ask us anything...';
    askInput.setAttribute('aria-label', 'Ask us anything. Your question opens the AXIS chat.');
    var send = el('button', 'axg-send');
    send.type = 'submit';
    send.setAttribute('aria-label', 'Send to the AXIS chat');
    send.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 12l16-8-6 16-2.5-6.5L4 12z" fill="currentColor"/></svg>';
    ask.appendChild(askInput); ask.appendChild(send);
    ask.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = askInput.value.trim();
      if (!q) { askInput.focus(); return; }
      // Called inside the submit event: Shopify accepts a starter message only during a real tap or key press.
      if (openChat(q.slice(0, 500), 'typed')) askInput.value = '';
    });

    panel.appendChild(head); panel.appendChild(log); panel.appendChild(choices); panel.appendChild(ask);
    panel.addEventListener('keydown', onKey);
    // Following a link closes the panel (the conversation is kept), so the next page is visible on a phone.
    panel.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (a && !/^(tel|mailto|sms):/.test(a.getAttribute('href'))) { state.open = false; save(); }
    });
    root.appendChild(launcher);
    root.appendChild(panel);
    stack();
    var tries = 0;
    (function poll() { if (!watchInbox() && ++tries < 30) setTimeout(poll, 1000); })();
    window.addEventListener('resize', stack);
    window.addEventListener('scroll', function () { if (!stack.q) { stack.q = true; requestAnimationFrame(function () { stack.q = false; stack(); }); } }, { passive: true });
    // Phones: the launcher tucks smaller while the page scrolls and comes back once it stops (axis-guide.css)
    var phone = window.matchMedia && window.matchMedia('(max-width: 599px)'), tuck;
    if (phone && !reduce) window.addEventListener('scroll', function () {
      if (!phone.matches) return;
      document.documentElement.classList.add('axg-scrolling');
      clearTimeout(tuck);
      tuck = setTimeout(function () { document.documentElement.classList.remove('axg-scrolling'); }, 600);
    }, { passive: true });

    if (!state.hinted && window.innerWidth >= 750) {
      setTimeout(function () { if (!state.open) launcher.classList.add('axg-hint'); }, 4000);
      setTimeout(function () { launcher.classList.remove('axg-hint'); }, 14000);
      state.hinted = true; save();
    }
  }

  // The 3D builder's phone bar (.fbv-dock, fixed to the bottom under 990px once its panel has scrolled away) would sit
  // under the launcher: while it shows, the launcher rides just above it.
  function stack() {
    var dock = document.querySelector('.fbv-dock.is-on');
    var r = dock && dock.getBoundingClientRect();
    var html = document.documentElement;
    if (r && r.height && r.top < window.innerHeight && getComputedStyle(dock).display !== 'none') {
      html.style.setProperty('--axg-stack', Math.round(window.innerHeight - r.top + 12) + 'px');
      html.classList.add('axg-stack');
    } else html.classList.remove('axg-stack');
  }

  // ---------- Shopify Inbox: one front door ----------
  function inbox() { var c = document.querySelector('shopify-chat'); return c && typeof c.show === 'function' ? c : null; }
  function openChat(message, kind) {
    var c = inbox();
    if (!c) return false;
    if (!panel.hidden) shut();
    c.show();
    if (message && typeof c.sendStarterMessage === 'function') {
      try { var p = c.sendStarterMessage(message, kind || 'typed'); if (p && p.catch) p.catch(function () {}); } catch (e) { /* the chat is open; they can type */ }
    }
    return true;
  }
  function deepFind(root, sel, depth) {
    if (!root || depth > 4) return null;
    var hit = root.querySelector(sel);
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) { hit = deepFind(all[i].shadowRoot, sel, depth + 1); if (hit) return hit; }
    return null;
  }
  function watchInbox() {
    if (watchInbox.done) return true;
    var c = inbox();
    if (!c) return false;
    watchInbox.done = true;
    ask.hidden = false;
    var seen = [], queued = false;
    function sync() {
      queued = false;
      watch(c.shadowRoot, 0);
      var on = !!deepFind(c.shadowRoot, '.activator__indicator--active', 0);
      launcher.classList.toggle('axg-unread', on);
      launcher.setAttribute('aria-label', on ? 'Chat: you have a reply from AXIS' : 'Chat with the ' + NAME);
    }
    var mo = window.MutationObserver ? new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(sync); } }) : null;
    function watch(root, depth) {
      if (!mo || !root || depth > 4) return;
      if (seen.indexOf(root) < 0) { seen.push(root); mo.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] }); }
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) watch(all[i].shadowRoot, depth + 1);
    }
    sync();
    return true;
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); shut(); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('button:not([disabled]), a[href], input:not([hidden]), [tabindex="0"]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    lastFocus = document.activeElement;
    state.open = true; save();
    launcher.classList.remove('axg-hint');
    panel.hidden = false;
    document.documentElement.classList.add('axg-is-open');
    requestAnimationFrame(function () { panel.classList.add('axg-panel--in'); });
    if (!log.childNodes.length) replay();
    focusChoice();
  }
  function shut() {
    state.open = false; save();
    panel.classList.remove('axg-panel--in');
    document.documentElement.classList.remove('axg-is-open');
    panel.hidden = true;
    setTimeout(stack, 50);
    (lastFocus && lastFocus !== document.body && lastFocus.focus && document.contains(lastFocus) ? lastFocus : launcher).focus();
  }
  function focusChoice() {
    var b = choices.querySelector('button, a');
    (b || log).focus({ preventScroll: true });
  }

  // ---------- conversation ----------
  function say(text, opts) {
    var b = el('div', 'axg-msg axg-msg--bot');
    if (typeof text === 'string') b.textContent = text; else b.appendChild(text);
    if (opts && opts.link) {
      var a = el('a', 'axg-link', opts.link.text);
      a.href = opts.link.href;
      if (/^https?:/.test(opts.link.href)) { a.target = '_blank'; a.rel = 'noopener'; }
      b.appendChild(document.createTextNode(' '));
      b.appendChild(a);
    }
    log.appendChild(b);
    scrollDown();
    return b;
  }
  function echo(text) {
    log.appendChild(el('div', 'axg-msg axg-msg--me', text));
    scrollDown();
  }
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  function offer(list) {
    choices.innerHTML = '';
    list.filter(Boolean).forEach(function (c) {
      var n;
      if (c.href) {
        n = el('a', 'axg-chip' + (c.primary ? ' axg-chip--primary' : ''), c.label);
        n.href = c.href;
      } else if (c.action) {
        n = el('button', 'axg-chip' + (c.primary ? ' axg-chip--primary' : ''), c.label);
        n.type = 'button';
        n.addEventListener('click', c.action);
      } else {
        n = el('button', 'axg-chip' + (c.primary ? ' axg-chip--primary' : ''), c.label);
        n.type = 'button';
        n.addEventListener('click', function () { go(c.step, c.args || [], c.label); });
      }
      choices.appendChild(n);
    });
  }

  function go(step, args, label) {
    if (label) echo(label);
    state.path.push([step, args, label || null]);
    save();
    run(step, args, false);
    if (!panel.hidden) focusChoice();
  }

  function replay() {
    log.innerHTML = '';
    if (!state.path.length) state.path = [['start', [], null]];
    state.path.forEach(function (p, i) {
      if (p[2]) echo(p[2]);
      run(p[0], p[1], i < state.path.length - 1);
    });
    save();
  }

  function menu() {
    return [
      { label: 'Which front wing for me?', step: 'discipline', primary: true },
      { label: 'Build a complete foil', href: flow.links.builder },
      { label: 'Will it fit my foil?', step: 'answer', args: ['fit'] },
      { label: 'Size guide', step: 'answer', args: ['sizes'] },
      { label: 'Shipping', step: 'answer', args: ['shipping'] },
      { label: 'Returns', step: 'answer', args: ['returns'] },
      { label: 'Warranty', step: 'answer', args: ['warranty'] },
      { label: 'My order', step: 'answer', args: ['order'] },
      { label: 'Talk to a person', step: 'person' },
    ];
  }

  var STEPS = {
    start: function () {
      say(inbox()
        ? "Hi, I'm the " + NAME + ", an automated guide. I can suggest a front wing for how you ride and start your build, check what fits, or answer the usual questions. Or type anything below: it goes to our chat and the AXIS team replies there."
        : "Hi, I'm the " + NAME + ", an automated guide. I can suggest a front wing for how you ride and start your build, check what fits, or answer the usual questions. For a person, tap Talk to a person.");
      offer(menu());
    },
    menu: function () {
      say('What else can I help with?');
      offer(menu());
    },
    discipline: function () {
      say('What do you ride, or want to ride?');
      offer(flow.disciplines.map(function (d) { return { label: d.label, step: 'level', args: [d.key] }; }));
    },
    level: function (d) {
      say('And where are you at?');
      offer(flow.levels.map(function (l) { return { label: l.label, step: 'weight', args: [d, l.key] }; })
        .concat([{ label: 'Back', step: 'discipline' }]));
    },
    weight: function (d, l) {
      say('Roughly what do you weigh? It helps pick the size.');
      offer(flow.weights.map(function (w) { return { label: w.label, step: 'results', args: [d, l, w.key] }; })
        .concat([{ label: 'Skip', step: 'results', args: [d, l, null] }]));
    },
    results: function (d, l, w) {
      var disc = find(flow.disciplines, d), lev = find(flow.levels, l), wt = w ? find(flow.weights, w) : null;
      var picks = ((flow.routes[d] || {})[l] || []).slice();
      var notes = [];
      if (wt) {
        picks = picks.filter(function (p) {
          if (p.maxKg && wt.kg >= p.maxKg) { if (p.overNote) notes.push(p.overNote); return false; }
          return true;
        });
        if (w === 'heavy' || w === 'xheavy') picks.sort(function (a, b) { return b.size - a.size; });
        if (w === 'light') picks.sort(function (a, b) { return a.size - b.size; });
        picks = picks.filter(function (p) { return p.lead; }).concat(picks.filter(function (p) { return !p.lead; }));
      }
      say('For ' + disc.label.toLowerCase() + ', ' + lev.label.toLowerCase() + ', these are the front wings I would start with. Pick one and the builder takes you through the rear wing, fuselage and mast, checking that every part fits.');
      var wrap = el('div', 'axg-cards');
      log.appendChild(wrap);
      picks.forEach(function (p) { wrap.appendChild(card(p)); });
      notes.forEach(function (n) { say(n); });
      scrollDown();
      var kit = flow.kits && flow.kits[d];
      offer([
        inbox() ? { label: 'Send my answers to the AXIS chat', primary: true, action: function () {
          var titles = [].map.call(wrap.querySelectorAll('.axg-card-title'), function (t) { return t.textContent; });
          var msg = 'Hi, I am choosing a foil: ' + disc.label.toLowerCase() + ', ' + lev.label.toLowerCase() + (wt ? ', ' + wt.label : '') + '.' +
            (titles.length ? ' The Foil Guide suggested: ' + titles.join('; ') + '.' : '') + ' Can you help me choose?';
          openChat(msg.slice(0, 500), 'typed');
        } } : null,
        kit ? { label: kit.label, href: builderUrl({ kit: kit.slug }) } : { label: 'Open the builder', href: flow.links.builder },
        { label: 'Start again', step: 'discipline' },
        { label: 'Talk to a person', step: 'person' },
        { label: 'Other questions', step: 'menu' },
      ]);
    },
    answer: function (key) {
      var a = flow.answers[key];
      say(a.text, { link: a.link });
      offer([
        key === 'order' && inbox() ? { label: 'Track my order in the chat', primary: true, action: function () { openChat('Track my order', 'suggestion_pill'); } } : null,
        { label: 'Which front wing for me?', step: 'discipline', primary: key !== 'order' || !inbox() },
        { label: 'Other questions', step: 'menu' },
        { label: 'Talk to a person', step: 'person' },
      ]);
    },
    person: function () {
      var live = !!inbox();
      say(live
        ? 'Chat with the AXIS team here and we will reply as soon as we can. Or send us a message through the contact form.'
        : 'Send us a message through the contact form, with your email, and the AXIS team will get back to you.');
      offer([
        live ? { label: 'Chat with us now', primary: true, action: function () { openChat(); } } : null,
        { label: 'Contact form', href: flow.contact.form, primary: !live },
        { label: 'Other questions', step: 'menu' },
      ]);
    },
  };

  function run(step, args, quiet) {
    var f = STEPS[step] || STEPS.start;
    f.apply(null, (args || []).concat([quiet]));
  }

  // ---------- front wing cards, live from the store ----------
  var cache = {};
  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?sections=axis-guide-product', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var tmp = document.createElement('div');
          tmp.innerHTML = j['axis-guide-product'] || '';
          var s = tmp.querySelector('[data-axis-guide-product]');
          if (!s) throw new Error('no product data');
          return JSON.parse(s.textContent);
        });
    }
    return cache[handle];
  }

  function card(pick) {
    var c = el('article', 'axg-card axg-card--loading');
    c.appendChild(el('p', 'axg-why', pick.why));
    product(pick.handle).then(function (p) {
      c.classList.remove('axg-card--loading');
      if (!p.available) { c.remove(); return; }
      var a = el('a', 'axg-card-link');
      a.href = p.url;
      if (p.image) {
        var im = el('img', 'axg-card-img');
        im.src = p.image; im.alt = p.imageAlt || ''; im.loading = 'lazy'; im.width = 120; im.height = 120;
        a.appendChild(im);
      }
      var t = el('div', 'axg-card-body');
      t.appendChild(el('h3', 'axg-card-title', p.title));
      t.appendChild(el('p', 'axg-price', (p.priceMin !== p.priceMax ? 'From ' : '') + money(p.priceMin)));
      a.appendChild(t);
      c.insertBefore(a, c.firstChild);
      var acts = el('div', 'axg-acts');
      var b = el('a', 'axg-btn axg-btn--primary', 'Build around this wing');
      // the builder names a link's setup after its kit= value when that is not one of its own kits: "Build a Surge 890 foil"
      b.href = builderUrl(pick.name ? { front: p.handle, kit: pick.name + ' foil' } : { front: p.handle });
      acts.appendChild(b);
      var more = el('a', 'axg-btn', 'View');
      more.href = p.url;
      acts.appendChild(more);
      c.appendChild(acts);
    }).catch(function () {
      c.classList.remove('axg-card--loading');
      var a = el('a', 'axg-link', 'See this wing');
      a.href = '/products/' + pick.handle;
      c.appendChild(a);
    });
    return c;
  }

  // ---------- boot ----------
  // Without a guide, Inbox's own button must show again (the snippet hides it from the first paint).
  function off() { if (!document.querySelector('.axg-launcher')) document.documentElement.classList.add('axg-off'); }
  function boot() {
    fetch(FLOW_URL).then(function (r) { return r.json(); }).then(function (f) {
      flow = f;
      build();
      if (state.open) open();
    }).catch(off);   // no guide is better than a broken one
    setTimeout(off, 15000);
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
  if (document.readyState === 'complete') idle(boot); else window.addEventListener('load', function () { idle(boot); });
})();
